import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";

export default function ManageReferralTypeModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [referralType, setReferralType] = useState(props.ageRangeType || {});
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    setReferralType(props?.referralType);
  }, [props?.ageRangeType]);

  const handleFormChange = (e) => {
    setValue(e.target.name, e.target.value);
    let _obj = {...referralType};
    _obj[e.target.name] = e.target.value;
    setReferralType({..._obj});
  };

  const [isNew, setIsNew] = useState(!!!props.referralType?.guid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(referralType)
  });

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };


  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form onSubmit={handleSubmit(handleSave)} id={'referralTypeForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Referral Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        {...register('name')}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Referral Type Name"}
                        autoComplete="off" required
                        className="form-control" id="name"
                        label="Referral Type"/>

                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}